import "./Header.scss";
import logo from "../assets/chorus_logo.png";
import { AppContext } from "../../context/AppContext";
import { useContext, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import RightSideBarPanel from "../SidePanel/RightSideBarPanel";
import { KEY_NAME } from "../../utils/KeyName";
import AxiosService from "../../utils/AxiosService";
import { useCustomSearchParams } from "../hooks/useCustomSearchParams";
import { SEARCH_PARAMS } from "../../utils/SearchParams";

function Header() {
  const { entityName, changeMaskedEntityShortName, maskedEntityShortName } =
    useContext(AppContext);
  const { entityType } = useParams();
  const location = useLocation();
  const { get } = useCustomSearchParams();

  const axiosService = new AxiosService();

  // Split path -> ["publisher", "publication-analytics"]
  const segments = location.pathname.split("/").filter(Boolean);

  const validRoots = [
    KEY_NAME.FUNDER,
    KEY_NAME.PUBLISHER,
    KEY_NAME.INSTITUTION,
  ];

  const showRightSidebar =
    segments.length >= 2 && validRoots.includes(segments[0]);

  useEffect(() => {
    const redirectEntityShortName = sessionStorage.getItem(
      "maskedEntityShortName",
    );
    const searchedEntityShortName = get(SEARCH_PARAMS.SHORT_NAME);

    if (!redirectEntityShortName) {
      switch (segments[0]) {
        case KEY_NAME.FUNDER:
          axiosService
            .getFundersList(searchedEntityShortName, false)
            .then((res) => {
              const responseDataLength = res.data.data?.length;

              if (!responseDataLength) {
                window.location.replace("/page-not-found");
              }
            })
            .catch();
          break;
        case KEY_NAME.PUBLISHER:
          axiosService
            .getPublishersList(searchedEntityShortName, false)
            .then((res) => {
              const responseDataLength = res.data.data?.length;

              if (!responseDataLength) {
                window.location.replace("/page-not-found");
              }
            })
            .catch();
          break;
        case KEY_NAME.INSTITUTION:
          axiosService
            .getInstitutionsList(searchedEntityShortName, false)
            .then((res) => {
              const responseDataLength = res.data.data?.length;

              if (!responseDataLength) {
                window.location.replace("/page-not-found");
              }
            })
            .catch();
          break;
        default:
      }
      // window.location.replace("/page-not-found");
    } else {
      // Clear the token so refreshing the page requires starting over
      changeMaskedEntityShortName(redirectEntityShortName);
      // sessionStorage.removeItem("maskedEntityShortName");
    }
  }, []);

  useEffect(() => {
    // console.log("maskedEntityShortName =>", maskedEntityShortName);
    if (!maskedEntityShortName) return;

    sessionStorage.removeItem("maskedEntityShortName");
    // window.location.replace("/page-not-found");
  }, [maskedEntityShortName]);

  return (
    <>
      {!location.pathname.includes("search-funder") &&
        !location.pathname.includes("preprints") && (
          <div className="header-container border border-end-0 shadow-sm">
            <div className="header-item d-flex align-items-center justify-content-between">
              {/* Left section */}
              <div className="d-flex align-items-center">
                <a
                  href="https://www.chorusaccess.org/"
                  className="d-inline-block text-decoration-none"
                >
                  <img
                    src={logo}
                    alt="Chorus Logo"
                    className="img-fluid logo-img"
                  />
                </a>

                {entityName ? (
                  <>
                    <div className="vertical-line mx-2 bg-theme rounded align-self-stretch"></div>
                    <h4 className="text-uppercase my-0 py-1">{entityName}</h4>
                  </>
                ) : (
                  <span className="mx-2">
                    Advancing Open Access to Research
                  </span>
                )}
              </div>
              {/* Right section (mobile only) */}
              {showRightSidebar && (
                <div className="mobile-hamburger">
                  <RightSideBarPanel />
                </div>
              )}
            </div>
          </div>
        )}
    </>
  );
}

export default Header;
